export default "__VITE_ASSET__BMTXEqoY__"